
import { useContext, useEffect, useRef } from 'react'
import { AppContext } from "../../../contextApi/ContextApi";

export default function DashboardCard({ _id, action, text, flag, setCurrentCard, child}) {
  const {accent_color, primary_color, secondary_color} = useContext(AppContext);
  const contentRef = useRef(null);
  const cardRef = useRef(null);

  // The card opening and scroll into view effect at any page render
  useEffect(() => {
    if(!contentRef || !cardRef || !contentRef.current || !cardRef.current) return;
    const content = contentRef.current;
    const card = cardRef.current;
    const removeTransitionEndListener = () => {
      content.removeEventListener("transitionend", handleTransitionEnd);
    };
    const handleTransitionEnd = async() => {
      await new Promise(resolve => setTimeout(resolve, 250))
      content.style.maxHeight = "fit-content";
      content.removeEventListener("transitionend", handleTransitionEnd);
      card.scrollIntoView({
        behavior: "smooth"
      });
    };
    if(flag){
      setCurrentCard(_id);
      content.style.maxHeight = "0px";
      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      });
      content.addEventListener("transitionend", handleTransitionEnd);
    }
    else{
      // setCurrentCard(null);
      content.style.maxHeight = content.scrollHeight + "px";
      requestAnimationFrame(() => {
        content.style.maxHeight = "0px";
        removeTransitionEndListener();
      })
    }
    return () => {
      removeTransitionEndListener();
    };
  }, [flag]);
  
  return (
    <div id={_id} style={{color:accent_color, textShadow:`2px 2px 3px ${primary_color}`}}>
        <div ref={cardRef} style={{backgroundColor:primary_color}} className={flag ? "dashboard_card_selected" :"dashboard_card"} onClick={action} dir='rtl'>{text}</div>
        <div ref={contentRef} className="dashboard_card_content" style={{backgroundColor:secondary_color}}>
            {child}
        </div>
    </div>
  )
}
